export const SITE_NAME = "Pentagon Properties";
export const SITE_TAGLINE = "Rental Properties in Halifax & Wolfville, Nova Scotia";
export const DEFAULT_TITLE = `${SITE_NAME} | ${SITE_TAGLINE}`;
export const DEFAULT_DESCRIPTION =
  "Pentagon Properties offers high-quality rental properties in Halifax and Wolfville, Nova Scotia, with in-house management, direct inquiries, and photo galleries for available units.";
export const DEFAULT_KEYWORDS =
  "Pentagon Properties, Halifax rental properties, Wolfville apartments, Nova Scotia rentals, Summer Street Suites, Main Street Apartments";
export const DEFAULT_IMAGE_PATH = "/pentagon.png";
export const CONTACT_EMAIL = "jamesgerard@pentagonproperties.ca";
export const CONTACT_PHONE = "+1-902-225-9634";
export const SERVICE_AREAS = [
  "Halifax, Nova Scotia",
  "Wolfville, Nova Scotia",
  "Nova Scotia",
];

function removeEmptyValues(value) {
  if (Array.isArray(value)) {
    return value
      .map(removeEmptyValues)
      .filter((item) => item !== undefined && item !== null && item !== "");
  }

  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value)
        .map(([key, nestedValue]) => [key, removeEmptyValues(nestedValue)])
        .filter(([, nestedValue]) => {
          if (Array.isArray(nestedValue)) {
            return nestedValue.length > 0;
          }

          if (nestedValue && typeof nestedValue === "object") {
            return Object.keys(nestedValue).length > 0;
          }

          return nestedValue !== undefined && nestedValue !== null && nestedValue !== "";
        })
    );
  }

  return value;
}

export function getAbsoluteUrl(pathname = "/") {
  if (typeof window === "undefined") {
    return pathname;
  }

  return new URL(pathname, window.location.origin).toString();
}

export function buildPropertyDescription(propertyLabel) {
  return `View photos, browse available units, and inquire about ${propertyLabel} with Pentagon Properties in Nova Scotia.`;
}

export function buildPropertyKeywords(propertyLabel) {
  return `${propertyLabel}, Pentagon Properties, Halifax rental properties, Wolfville apartments, Nova Scotia rentals`;
}

export function buildOrganizationStructuredData() {
  return removeEmptyValues({
    "@context": "https://schema.org",
    "@type": "Organization",
    areaServed: SERVICE_AREAS.map((areaName) => ({
      "@type": "AdministrativeArea",
      name: areaName,
    })),
    description: DEFAULT_DESCRIPTION,
    email: CONTACT_EMAIL,
    foundingDate: "2023",
    logo: getAbsoluteUrl(DEFAULT_IMAGE_PATH),
    name: SITE_NAME,
    telephone: CONTACT_PHONE,
    url: getAbsoluteUrl("/"),
  });
}

export function buildWebsiteStructuredData() {
  return removeEmptyValues({
    "@context": "https://schema.org",
    "@type": "WebSite",
    description: DEFAULT_DESCRIPTION,
    inLanguage: "en-CA",
    name: SITE_NAME,
    url: getAbsoluteUrl("/"),
  });
}

export function buildPropertyStructuredData(property, pathname) {
  return removeEmptyValues({
    "@context": "https://schema.org",
    "@type": "ApartmentComplex",
    description: buildPropertyDescription(property?.label || SITE_NAME),
    name: property?.label || SITE_NAME,
    numberOfAccommodationUnits: property?.units?.length || undefined,
    provider: {
      "@type": "Organization",
      name: SITE_NAME,
      url: getAbsoluteUrl("/"),
    },
    url: getAbsoluteUrl(pathname),
  });
}

export function buildBreadcrumbStructuredData(items) {
  return removeEmptyValues({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      item: getAbsoluteUrl(item.path),
      name: item.name,
      position: index + 1,
    })),
  });
}
